export default function NotFound(): JSX.Element {
	return (
		<div>App status not found</div>
	);
}
